import styled, { createGlobalStyle } from 'styled-components';

export const Takeover = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #fff;
  overflow-y: auto;
`;

export const TakeoverScrollLock = createGlobalStyle`
  body {
    overflow: hidden;
    touch-action: none;
    overscroll-behavior: none;
  }
`;
